// IE 2026 10 16 / ODOO-5800 (Igor 16.10, скрин «M03 Marketing plan · CF»: выделена ячейка строки «ACT 2026» в колонке «Показник», объединённой по
// горизонтали с соседними; Cmd+C даёт ПУСТОЙ буфер; «также при копировании содержимого ячеек обрезай входящие / исходящие пробелы, табы»).
// Причина: AttrGrid.copy_collect читает getCellData выделенной (row, col), а у объединения wijmo выделение — ОДНА ячейка, обычно левая, пустая:
// значение объединения лежит в колонке-источнике (merge_src у CustomMergeManager; у merge «назад» — первая колонка со значением), сама строка
// буфера собиралась из пустых колонок → '' (или одни табы при выделении всего диапазона). Здесь — чистая логика (без DOM / wijmo):
//   copyMerged_cell   — ячейка выделения → откуда читать (srcCol) и куда класть (icol): объединённый диапазон идёт в буфер ОДИН раз, в левой
//                       выделенной колонке диапазона, остальные его колонки в выделении помечаются как пройденные (без пустых табов);
//   copyMerged_trim   — текст ячейки без пробелов / табов / переводов строки по краям;
//   copyMerged_matrix — строки буфера (TSV) из собранных ячеек (перенесено из AttrGrid.copy_matrix без изменений + trim).
// Выключатель fe.ux.copyMergedTrim (дефолт ВКЛ; false — как до правки: по выделенной ячейке, текст как есть).
export const COPY_MERGED_TRIM_FLAG = 'fe.ux.copyMergedTrim'

export function copyMergedTrim_on(setting) {
    try { return typeof setting === 'function' ? setting(COPY_MERGED_TRIM_FLAG, true) !== false : true } catch (e) { return true }
}

// текст ячейки для буфера: без пробелов, табов, NBSP и переводов строки по краям (String.prototype.trim — все пробельные символы Unicode)
export function copyMerged_trim(s) {
    return (s === null || s === undefined) ? '' : String(s).trim()
}

// колонка-источник значения объединённого диапазона rng {col, col2}: preferred (merge_src из кэша), если в ней есть текст; иначе первая колонка
// диапазона с непустым текстом; иначе левая колонка диапазона
export function copyMerged_source(rng, getText, preferred) {
    const has = (c) => { try { return copyMerged_trim(getText(c)) !== '' } catch (e) { return false } }
    if (Number.isInteger(preferred) && preferred >= rng.col && preferred <= rng.col2 && has(preferred)) return preferred
    for (let c = rng.col; c <= rng.col2; c++) if (has(c)) return c
    return rng.col
}

// ячейка (irow, icol) выделенного диапазона range {leftCol, rightCol} → { icol, srcCol, mergeCol } или null (уже пройдена). getMerged(irow, icol) →
// {col, col2} | null — объединение wijmo (CustomMergeManager, clip=true); getText(irow, icol) — текст ячейки (getCellData); preferredSrc(irow, icol) —
// колонка-источник из кэша (merge_src) или undefined; seen — Set пройденных ключей `${irow}-${icol}`, общий для всех диапазонов выделения.
// Объединение по колонкам — в буфер один раз: icol = левая выделенная колонка диапазона, srcCol — колонка значения; все колонки диапазона внутри
// выделения помечаются пройденными. Объединение только по строкам (col === col2) и обычная ячейка — как есть
export function copyMerged_cell(irow, icol, range, getMerged, getText, preferredSrc, seen) {
    const key = `${irow}-${icol}`
    if (seen.has(key)) return null
    let rng = null
    try { rng = getMerged(irow, icol) } catch (e) { rng = null }
    if (!rng || !Number.isInteger(rng.col) || !Number.isInteger(rng.col2) || rng.col === rng.col2) {
        seen.add(key)
        return { icol, srcCol: icol, mergeCol: null }
    }
    const mkey = `${irow}-m${rng.col}`   // ключ объединения: другой диапазон выделения по тому же объединению его не повторит
    if (seen.has(mkey)) { seen.add(key); return null }
    const c1 = Math.max(rng.col, range.leftCol), c2 = Math.min(rng.col2, range.rightCol)
    for (let c = c1; c <= c2; c++) seen.add(`${irow}-${c}`)
    seen.add(key); seen.add(mkey)
    let pref
    try { pref = typeof preferredSrc === 'function' ? preferredSrc(irow, icol) : undefined } catch (e) { pref = undefined }
    const srcCol = copyMerged_source(rng, (c) => getText(irow, c), pref)
    return { icol: c1, srcCol, mergeCol: rng.col }
}

// собранные ячейки data [{ irow, icol, valueStr }] → { sortedRows, sortedCols, text }: TSV строк буфера (объединение колонок всех строк; ячейка с
// табом / переводом строки / кавычкой — в кавычках, кавычки удвоены). trim — текст каждой ячейки через copyMerged_trim
export function copyMerged_matrix(data, trim) {
    const rows = {}, colSet = new Set()
    for (const V of data) {
        if (!rows[V.irow]) rows[V.irow] = {}
        rows[V.irow][V.icol] = trim ? copyMerged_trim(V.valueStr) : (V.valueStr ?? '')
        colSet.add(V.icol)
    }
    const sortedRows = Object.keys(rows).sort((a, b) => +a - +b)
    const sortedCols = [...colSet].sort((a, b) => a - b).map(String)
    const escape = s => /[\t\n\r"]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s
    const text = sortedRows.map(r => sortedCols.map(c => escape(String(rows[r]?.[c] ?? ''))).join('\t')).join('\n')
    return { sortedRows, sortedCols, text }
}
